import { IntlShape } from 'react-intl';

import { EIterableMessageType } from './Notifications';

export const getEmailOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: 'Guest Newsletter',
        id: 'Ktb53F',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Get news, tips, stories, events, travel inspirations, and special highlights.',
        id: 'Ihwmpz',
      }),
      id: EIterableMessageType.GuestNewsletter,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Guest Promotions',
        id: 'E+b6tq',
      }),
      description: intl.formatMessage({
        defaultMessage: 'Unlock exclusive deals and special offers tailored just for you.',
        id: 'NiM0cN',
      }),
      id: EIterableMessageType.GuestPromotions,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Guest Campground Promotions',
        id: 'nh4zzW',
      }),
      description: intl.formatMessage({
        defaultMessage: 'Discover amazing campground deals and unique stays.',
        id: 'GrZnx0',
      }),
      id: EIterableMessageType.GuestCampgroundPromotions,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Outdoorsy Bayfield Newsletter',
        id: '9iVI17',
      }),
      description: intl.formatMessage({
        defaultMessage: 'Receive local news, outdoor activities, upcoming events, and travel tips.',
        id: 'NjSVmE',
      }),
      id: EIterableMessageType.BayfieldNewsletter,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Outdoorsy Texas Hill Country Newsletter',
        id: 'MId0Fw',
      }),
      description: intl.formatMessage({
        defaultMessage: 'Receive updates on local events, outdoor adventures and travel guides.',
        id: 'ZouMUs',
      }),
      id: EIterableMessageType.TexasHillCountryNewsletter,
    },
    {
      label: intl.formatMessage({
        defaultMessage: 'Outdoorsy Yosemite Newsletter',
        id: 'E/ZpXu',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Receive the latest news, hiking tips, wildlife sightings, and event updates.',
        id: 'fDyzeZ',
      }),
      id: EIterableMessageType.YosemiteNewsletter,
    },
  ];
};

export const getSMSIterableOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: 'Guest promotions',
        id: 'nHMEoA',
      }),
      description: intl.formatMessage({
        defaultMessage: 'Unlock exclusive deals and special offers tailored just for you.',
        id: 'NiM0cN',
      }),
      ariaLabel: intl.formatMessage({
        defaultMessage: 'SMS notification guest promotions',
        id: 'a1JWf3',
      }),
      id: EIterableMessageType.GuestSMSPromotions,
    },
  ];
};

export const getPushOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        defaultMessage: 'Guest promotions',
        id: 'nHMEoA',
      }),
      description: intl.formatMessage({
        defaultMessage: 'Unlock exclusive deals and special offers tailored just for you.',
        id: 'NiM0cN',
      }),
      ariaLabel: intl.formatMessage({
        defaultMessage: 'Push notification guest promotions',
        id: 'aafPzc',
      }),
      id: EIterableMessageType.GuestPushPromotions,
    },
  ];
};
